module.exports = __webpack_public_path__ + "assets/img/Advanced_btn.bf8430cb.png";